import React from 'react'

interface PageWrapperProps {
  children: React.ReactNode
  className?: string
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ children, className }) => {
  return (
    <div
      className={`min-w-0 flex-grow overflow-y-auto bg-surface-hover p-4 pb-20 text-text-primary sm:pb-4 md:p-8 ${
        className ?? ''
      }`}
    >
      {children}
    </div>
  )
}
